/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/anchor-is-valid */
import {useState, useRef, useEffect} from 'react'
import {createPortal} from 'react-dom'
import {Modal} from 'react-bootstrap'
import { useToast } from '../../../components/Toats';
import { StepperComponent } from '../../../../../_metronic/assets/ts/components';
import { getProposalOne } from '../../../../services/proposalsService';
import { Loading } from '../../../components/Loadings/loading';
import { KTSVG } from '../../../../../_metronic/helpers';
import { ItemProposalDetails } from './components/intemProposalsDetails';
import { DescriptionProposal } from './components/descriptionProposal';
import { ServicesQtdProposal } from './components/servicesQtdProposal';
import { TemplateProposal } from './components/templateProposal';

type Props = {
    id: string;
    handleClose: () => void
    data: any
    prevStep: any;
    submitStep: any;
    isSubmitButton: any;
}


const modalsRoot = document.getElementById('root-modals') || document.body

const ScreenDetailsProposals = ({handleClose, id, isSubmitButton, prevStep, data}: Props) => {

  const { toggleToast } = useToast();
  const stepperRef = useRef<HTMLDivElement | null>(null)
  const stepper = useRef<StepperComponent | null>(null)
  const [loading, setLoading] = useState(false)
  const [proposal, setProposal] = useState<any>(null);

  const getProposal = async () => {
    try {
      if(data && data.id){
        setLoading(true)
        const myProposal = await getProposalOne(data && data.id ? data.id : "")
        setProposal(myProposal)
      }
    } catch (error) {
        console.log(error)
        toggleToast("Erro ao buscar a proposta. ", "error")
    }finally{
        setLoading(false)
    }
  }

  // const deleteOSSubmit = async () => {
  //   try {
  //     setLoading(true)
    
  //     await deleteServiceOne(id)
  //     toggleToast("Sucesso ao deletar a O.S. ", "success")

  //   } catch (error) {
  //     console.log('erro',error)
  //     toggleToast("Erro ao deletar a O.S. ", "error")
  //   }finally{
  //     setLoading(false)
  //     closed()
  //     // handleClose()
  //   //   setTimeout(()=>{
  //   //     window.location.reload()
  //   //   }, 2000);
  //   }
  // }

  const refresh = () => {
    getProposal()
  }

  const submit = () => {
    //deleteOSSubmit()
  }

  useEffect(() => {
    getProposal()
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);

  if (loading) {
    return (
      <div className='spinnerLoadingDashboard'>
        <Loading myClass='spinner-border spinnerDashboard'/>
      </div>
    );
  }


  return (
    <div className='modal-body py-lg-10 px-lg-10 bg-light' style={{marginLeft: '5%', marginRight: '5%'}}>
        <div
          ref={stepperRef}
          className='stepper stepper-pills stepper-column d-flex flex-column flex-xl-row flex-row-fluid'
          id='kt_modal_create_app_stepper'
        >
          <div className='flex-row-fluid py-lg-0'>
            <div style={{marginBottom: '3rem', display: 'flex', flexDirection: 'column', gap: '1rem'}}>
                
                {/* <h3 className='card-title align-items-start flex-column'>
                    <span className='text-muted mt-1 fw-semibold fs-5'>Deseja deletar essa O.S permanentemente?</span>
                </h3> */}
                
                <ItemProposalDetails 
                  itemProposal={proposal}
                  refresh={refresh}
                />

                <DescriptionProposal
                  itemProposal={proposal}
                  refresh={refresh}
                />

                <ServicesQtdProposal
                  itemProposal={proposal}
                  refresh={refresh}
                />

                <TemplateProposal
                  itemProposal={proposal}
                  refresh={refresh}
                />

            </div>
          </div>
        </div>


        <div className='d-flex flex-stack pt-15'>
            <div className='mr-2'>
            <button
                onClick={prevStep}
                type='button'
                className='btn btn-lg btn-light-primary me-3'
                data-kt-stepper-action='previous'
            >
                <KTSVG
                path='/media/icons/duotune/arrows/arr063.svg'
                className='svg-icon-4 me-1'
                />
                Voltar
            </button>
            </div>

            <div>
            <button onClick={handleClose} className='btn btn-lg btn-primary me-3'>
                <span className='indicator-label'>
                {!isSubmitButton && 'Continuar'}
                {isSubmitButton && 'Salvar'}
                <KTSVG
                    path='/media/icons/duotune/arrows/arr064.svg'
                    className='svg-icon-3 ms-2 me-0'
                />
                </span>
            </button>
            </div>
        </div>
    </div>
  )
}

export {ScreenDetailsProposals }
